import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as _ from 'lodash';

import { useDropdown } from './DropdownContext';
import Portal from './Portal';
import { messageUtility } from '../../../utilities/messageUtility';
import {
  FormDropdownClearButton,
  FormDropdownRadio,
} from '../../CommonFormComponents';
import InfinityScrollLoad from '../../InfinityScrollLoad';

const getCoordsDropdown = (decoratorRef, dropdownRef) => {
  const decoratorRect = decoratorRef.current.getBoundingClientRect();
  const dropdownRect = dropdownRef.current.getBoundingClientRect();
  let top;
  let left;
  let isTop = false;
  if (decoratorRect.bottom + dropdownRect.height < window.innerHeight) {
    top = decoratorRect.bottom;
  } else if (decoratorRect.y - dropdownRect.height > 0) {
    top = decoratorRect.y - dropdownRect.height;
    isTop = true;
  } else {
    top = window.innerHeight - dropdownRect.height;
  }

  if (decoratorRect.x + dropdownRect.width < window.innerWidth) {
    left = decoratorRect.x;
  } else if (decoratorRect.right - dropdownRect.width > 0) {
    left = decoratorRect.right - dropdownRect.width;
  } else {
    left = 0;
  }
  return {
    top: top + window.scrollY,
    left: left + window.scrollX,
    isTop,
  };
};

export const List = ({ children, cssClass = '' }) => {
  const {
    isShowDropdown,
    decoratorRef,
    dropdownRef,
    handleToggleDropdown,
  } = useDropdown();
  const [coords, setCoords] = useState({});
  let initScrollLeft = null;
  const rootElm = document.querySelector('[wj-part="root"]');

  const handleSetCoords = () => {
    const coords = getCoordsDropdown(decoratorRef, dropdownRef);
    setCoords(coords);
  };

  const handleHideDropdown = () => {
    if (initScrollLeft !== rootElm.scrollLeft) {
      handleToggleDropdown();
    }
  };

  const handleScroll = () => {
    handleSetCoords();
    handleHideDropdown();
  }

  useLayoutEffect(() => {
    if (!isShowDropdown || !decoratorRef || !dropdownRef) {
      return;
    }
    initScrollLeft = rootElm.scrollLeft;
    handleSetCoords();
    if (rootElm) {
      rootElm.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (isShowDropdown && decoratorRef && dropdownRef) {
        if (rootElm) {
          rootElm.removeEventListener('scroll', handleScroll);
        }
      }
    };
  }, [isShowDropdown]);

  if (!isShowDropdown) {
    return null;
  }

  return (
    <Portal>
      <div
        id='form-dropdown-list'
        className='dropdown dropdown--dropdown-list show drop-down-portal'
        style={{ ...coords, position: 'absolute' }}
      >
        <div
          className={`dropdown__item dropdown__item--hidden ${cssClass} ${
            coords.isTop ? 'dropdown__item--top' : ''
          }`}
          ref={dropdownRef}
        >
          {children}
        </div>
      </div>
    </Portal>
  );
};

export const RadioItems = () => {
  const {
    data,
    isLoading,
    handleSelectedRow,
    selected,
    handleInView,
    targetId,
    fieldName,
    fieldValue,
    options,
  } = useDropdown();
  const [resetScroll, setResetScroll] = useState(false);

  useEffect(() => {
    setResetScroll(true);
  }, []);

  return (
    <div className='dropdown-single-select__item'>
      <div className='dropdown-single-select__scroll' id={targetId}>
        <ul className='single-select'>
          {_.map(data, (item, index) => (
            <FormDropdownRadio
              key={_.get(item, fieldValue, index)}
              option={item}
              checked={selected === _.get(item, fieldValue)}
              handleSelectedRow={handleSelectedRow}
              column={fieldValue}
            >
              {_.get(item, fieldName)}
            </FormDropdownRadio>
          ))}
          {_.isEmpty(options) && (
            <InfinityScrollLoad
              reset={resetScroll}
              targetId={targetId}
              total={_.size(data)}
              isLoading={isLoading}
              callback={handleInView}
            />
          )}
        </ul>
      </div>
    </div>
  );
};

export const Search = () => {
  const { searchName, handleOnChangeName } = useDropdown();
  return (
    <div className='dropdown-single-select__item'>
      <i className='i-search i-2x' />
      <input
        type='text'
        placeholder={messageUtility.getMessage('I-000-090')}
        defaultValue={searchName}
        onChange={e => handleOnChangeName(e.target.value)}
      />
    </div>
  );
};

export const ClearSelect = () => {
  const { handleClearSelectedRow } = useDropdown();
  return (
    <div className='dropdown-single-select__item'>
      <FormDropdownClearButton onClick={handleClearSelectedRow} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/dropdowns/portal/DropdownComponents.jsx